import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { login, selectAuth, setDummyAuth } from '../../store/auth/authSlice';
import './Login.css';

interface LocationState {
  from?: {
    pathname: string;
  };
}

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, error, isAuthenticated } = useAppSelector(selectAuth);

  const state = location.state as LocationState;
  const from = state?.from?.pathname || '/';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // admin 계정으로 로그인 시도
    if (username.toLowerCase() === 'admin') {
      try {
        const result = await dispatch(login({ username, password }));
        if (login.fulfilled.match(result)) {
          navigate(from, { replace: true });
        }
      } catch (error) {
        console.error('Admin login failed:', error);
      }
    } else {
      // 일반 사용자는 더미 토큰 사용
      const dummyToken = 'dummy-jwt-token-for-register-system';
      const dummyUser = {
        username: username || 'register-user',
        role: 'ROLE_USER'
      };

      localStorage.setItem('token', dummyToken);
      dispatch(setDummyAuth({
        user: dummyUser,
        token: dummyToken
      }));
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>로그인</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">사용자명</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="admin 또는 아무 이름"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">비밀번호</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="admin인 경우 실제 비밀번호"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
        <div className="login-info">
          <p><strong>사용 방법:</strong></p>
          <ul>
            <li><strong>Admin 로그인:</strong> 사용자명에 "admin" 입력 + 실제 비밀번호</li>
            <li><strong>일반 접속:</strong> 아무 이름 입력 (비밀번호 불필요)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Login; 